import { init } from '@noriginmedia/norigin-spatial-navigation'

const setupFocus = () => {
  init({
    debug: false,
    visualDebug: false,
    throttleKeypresses: true,
    throttle: 100,
  })
}

export default setupFocus
